import styled from 'styled-components';

const NAV_BAR_HEIGHT = 56;
const HEADER_HEIGHT = 54; // When it is all in the same line
const TITLE_HEIGHT = 100;
const BUTTON_HEIGHT = 70;
const LEFT_VERTICAL_HEIGHT = NAV_BAR_HEIGHT + HEADER_HEIGHT + TITLE_HEIGHT + BUTTON_HEIGHT;

const PreviewContainer = styled.div`
  height: calc(100vh - ${LEFT_VERTICAL_HEIGHT}px);
`;

export default {
  PreviewContainer
};
